export enum Components {
  ActivityDefinition = 0,
  ConditionDefinition = 1,
  FindingDefinition = 2,
  ObservationDefinition = 3,
  CodeableConcept = 4,
}
